export default {
    movies: "/",
    movie: "/:id",
  };
